import { Col, Input, Label, Row } from "reactstrap";
import { PublishStatus } from "../../../../../../Utils/Constants";
import { P } from "../../../../../../AbstractElements";
import { setFormValue } from "../../../../../../ReduxToolkit/Reducers/AddProductSlice";
import { useAppDispatch } from "../../../../../../ReduxToolkit/Hooks";

const SelectFour = () => {
  const dispatch = useAppDispatch()
  const handleStatus = (select:string) => {
    dispatch(setFormValue({name:"status",value:select}))
  }
  return (
    <Col sm="6">
      <Row>
        <Col xs="12">
          <Label for="validationServer01">{PublishStatus}</Label>
          <Input type="select" name="status" onChange={(e)=>handleStatus(e.target.value)}>
            <option>Publish</option>
            <option>Drafts</option>
            <option>Unpublish</option>
          </Input>
          <P className="f-light">Choose the status</P>
        </Col>
      </Row>
    </Col>
  );
};

export default SelectFour;
